
    import * as React from 'react';

    const Chat16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" style={svgStyle}><desc>{"Created with Sketch."}</desc><g id="Chat_16_svg__Icons/Chat/16" stroke="none" strokeWidth={1} fillRule="evenodd"><path d="M1,2 L15,2 L15,12 L9,12 L4,15 L4,12 L1,12 L1,2 Z M2,3 L2,11 L5,11 L5,13.2338096 L8.72301604,11 L14,11 L14,3 L2,3 Z" id="Chat_16_svg__Rectangle" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Chat16.displayName = 'Chat16';

    export default Chat16;
  